import Tooltip from 'Components/Atoms/Tooltip/Tooltip';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { fetchBusinessUnitDataset } from 'Store/BusinessUnit/Actions';
import { getBusinessUnitDataset } from 'Store/BusinessUnit/Selectors';
import { fetchCandidateDataset } from 'Store/Candidate/Actions';
import { getCandidateDataset } from 'Store/Candidate/Selectors';
import { fetchContactDataset } from 'Store/Contact/Actions';
import { getContactDataset } from 'Store/Contact/Selectors';
import { StoreState } from 'Store/Reducers';
import { fetchVacancyDataset } from 'Store/Vacancy/Actions';
import { getVacancyDataset } from 'Store/Vacancy/Selectors';
import styles from '../ContactHeader.module.sass';

const ContactHeaderItem = ({
    values,
    entity_name,

    candidateDatasetById,
    vacancyDatasetById,
    businessUnitDatasetById,
    contactDatasetById,

    ...props
}: ContactHeaderItemProps) => {
    const navigate = useNavigate();
    const [tooltipRef, setTooltipRef] = useState<any>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleTooltipHover = (value: boolean) => () => setShowTooltip(value);

    useEffect(() => {
        EntityHelper.fetchDatasetByDatasetId(props, entity_name);
    }, []);

    return <span
        ref={setTooltipRef}
        onMouseEnter={handleTooltipHover(true)}
        onMouseLeave={handleTooltipHover(false)}
        className={styles['contactheader__list-item-primary']}
    >({values?.length} {
        values?.length === 1
        ? EntityHelper.getSingularDisplayValueByName(entity_name)?.toLowerCase()
        : EntityHelper.getDisplayValueByName(entity_name)?.toLowerCase()
    })
        {
            showTooltip &&
            <Tooltip ref={tooltipRef}>
                {
                    values?.map((j: any, idx: number) => 
                        <span onClick={() => navigate(EntityHelper.getEntityRoute(entity_name, j))}>
                            { idx !== 0 && ','} {
                                {
                                    ...candidateDatasetById,
                                    ...vacancyDatasetById,
                                    ...businessUnitDatasetById,
                                    ...contactDatasetById
                                }?.[j]
                            }
                        </span>    
                    )
                }
            </Tooltip>
        }
    </span>;
}

interface Props {
    entity_name: string
    values: any[]
}

const mapState = (state: StoreState, props: Props) => ({
    candidateDatasetById: getCandidateDataset(state),
    vacancyDatasetById: getVacancyDataset(state),
    businessUnitDatasetById: getBusinessUnitDataset(state),
    contactDatasetById: getContactDataset(state),
});

const mapDispatch = {
    fetchCandidateDataset,
    fetchVacancyDataset,
    fetchContactDataset,
    fetchBusinessUnitDataset
}

type ContactHeaderItemProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(ContactHeaderItem);